export default __webpack_public_path__ + "locales/uk-UA/FillPDFDialog.json?hash=835caa1db4c6cd56be1b76255f39b8a4";